module.exports = __webpack_public_path__ + "img/img-box-2021-right.efd5cc38.png";